// Any start of a PAN, so a character out of place shows as it is typed: letters 1-5, digits 6-9,
// then a letter.
const PAN_PREFIX_PATTERN = /^([A-Z]{0,5}|[A-Z]{5}\d{0,4}|[A-Z]{5}\d{4}[A-Z])$/

export const PAN_LENGTH = 10

export const normalizePan = (value: string): string => value.replace(/\s/g, '').toUpperCase()

export const isPanPrefix = (pan: string): boolean => PAN_PREFIX_PATTERN.test(pan)

// The 4th character is the holder type, and only P (a person) can verify as an individual.
export const isPersonalPan = (pan: string): boolean =>
  pan.length === PAN_LENGTH && isPanPrefix(pan) && pan[3] === 'P'
